// frontend/src/pages/Perfil.jsx
import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';
import '../styles/Perfil.css';

const Perfil = () => {
  const { user, logout } = useAuth();
  const [loading, setLoading] = useState(true);
  const [editMode, setEditMode] = useState(false);
  const [changePasswordMode, setChangePasswordMode] = useState(false);
  const [actividad, setActividad] = useState({
    documentos: [],
    eventos: [],
    notificaciones: []
  });
  const [formData, setFormData] = useState({
    nombre: '',
    telefono: '',
    email: ''
  });
  const [passwordData, setPasswordData] = useState({
    passwordActual: '',
    passwordNueva: '',
    confirmPassword: ''
  });
  const [activeTab, setActiveTab] = useState('perfil');

  useEffect(() => {
    cargarPerfil();
    cargarActividad();
  }, []);

  const cargarPerfil = async () => {
    try {
      const response = await api.get('/usuarios/perfil/mi-perfil');
      const userData = response.data.data;
      setFormData({
        nombre: userData.nombre || '',
        telefono: userData.telefono || '',
        email: userData.email || ''
      });
    } catch (error) {
      console.error('Error al cargar perfil:', error);
    }
  };

  const cargarActividad = async () => {
    try {
      const response = await api.get('/usuarios/perfil/actividad');
      setActividad(response.data.data);
    } catch (error) {
      console.error('Error al cargar actividad:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleGuardarPerfil = async (e) => {
    e.preventDefault();
    
    try {
      const response = await api.put('/usuarios/perfil/actualizar', {
        nombre: formData.nombre,
        telefono: formData.telefono
      });
      
      alert('✅ Perfil actualizado correctamente');
      setEditMode(false);
      // Actualizar el contexto de autenticación si es necesario
    } catch (error) {
      console.error('Error al actualizar perfil:', error);
      alert(error.response?.data?.msg || 'Error al actualizar el perfil');
    }
  };

  const handleCambiarPassword = async (e) => {
    e.preventDefault();
    
    if (passwordData.passwordNueva !== passwordData.confirmPassword) {
      alert('❌ Las contraseñas no coinciden');
      return;
    }

    if (passwordData.passwordNueva.length < 6) {
      alert('❌ La contraseña debe tener al menos 6 caracteres');
      return;
    }

    try {
      await api.put('/usuarios/perfil/cambiar-password', {
        passwordActual: passwordData.passwordActual,
        passwordNueva: passwordData.passwordNueva
      });
      
      alert('✅ Contraseña cambiada correctamente');
      setChangePasswordMode(false);
      setPasswordData({
        passwordActual: '',
        passwordNueva: '',
        confirmPassword: ''
      });
    } catch (error) {
      console.error('Error al cambiar contraseña:', error);
      alert(error.response?.data?.msg || 'Error al cambiar la contraseña');
    }
  };

  const getRoleName = (role) => {
    const roles = {
      'super_admin_jasp': 'Super Administrador',
      'admin_jasp': 'Administrador',
      'consultor_1': 'Consultor Nivel 1',
      'consultor_2': 'Consultor Nivel 2',
      'consultor_3': 'Consultor Nivel 3',
      'institucion': 'Institución'
    };
    return roles[role] || role;
  };

  const getInitials = (name) => {
    if (!name) return 'U';
    return name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
  };

  if (loading) {
    return (
      <div className="perfil-loading">
        <div className="loading-spinner"></div>
        <p>Cargando perfil...</p>
      </div>
    );
  }

  return (
    <div className="perfil">
      <div className="perfil-header">
        <h1>Mi Perfil</h1>
        <p>Gestiona tu información personal y preferencias</p>
      </div>

      <div className="perfil-grid">
        {/* Columna izquierda - Información básica */}
        <div className="perfil-col">
          <div className="perfil-card">
            <div className="perfil-avatar-section">
              <div className="perfil-avatar">
                {getInitials(formData.nombre)}
              </div>
              <div>
                <h2>{formData.nombre}</h2>
                <p className="perfil-role">{getRoleName(user?.role)}</p>
                {user?.institucion && (
                  <p className="perfil-institucion">
                    🏢 {user.institucion.nombre}
                  </p>
                )}
              </div>
            </div>

            <div className="perfil-info">
              {!editMode ? (
                <>
                  <div className="info-item">
                    <label>Email</label>
                    <p>{formData.email}</p>
                  </div>
                  <div className="info-item">
                    <label>Teléfono</label>
                    <p>{formData.telefono || 'No especificado'}</p>
                  </div>
                  <div className="info-item">
                    <label>Miembro desde</label>
                    <p>{user?.fechaRegistro ? new Date(user.fechaRegistro).toLocaleDateString() : '—'}</p>
                  </div>
                  <div className="info-item">
                    <label>Último acceso</label>
                    <p>{user?.ultimoAcceso ? new Date(user.ultimoAcceso).toLocaleString() : '—'}</p>
                  </div>

                  <div className="perfil-actions">
                    <button 
                      className="btn-primary"
                      onClick={() => setEditMode(true)}
                    >
                      Editar Perfil
                    </button>
                    <button 
                      className="btn-secondary"
                      onClick={() => setChangePasswordMode(true)}
                    >
                      Cambiar Contraseña
                    </button>
                  </div>
                </>
              ) : (
                <form onSubmit={handleGuardarPerfil} className="perfil-form">
                  <div className="form-group">
                    <label>Nombre completo</label>
                    <input
                      type="text"
                      value={formData.nombre}
                      onChange={(e) => setFormData({...formData, nombre: e.target.value})}
                      className="form-control"
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label>Email</label>
                    <input
                      type="email"
                      value={formData.email}
                      className="form-control"
                      disabled
                    />
                    <small className="text-muted">El email no se puede cambiar</small>
                  </div>

                  <div className="form-group">
                    <label>Teléfono</label>
                    <input
                      type="text"
                      value={formData.telefono}
                      onChange={(e) => setFormData({...formData, telefono: e.target.value})}
                      className="form-control"
                      placeholder="Ej: 555-123-4567"
                    />
                  </div>

                  <div className="form-actions">
                    <button type="button" className="btn-secondary" onClick={() => setEditMode(false)}>
                      Cancelar
                    </button>
                    <button type="submit" className="btn-primary">
                      Guardar Cambios
                    </button>
                  </div>
                </form>
              )}
            </div>
          </div>

          {/* Modal de cambio de contraseña */}
          {changePasswordMode && (
            <div className="modal-overlay">
              <div className="modal-content">
                <h2>Cambiar Contraseña</h2>
                
                <form onSubmit={handleCambiarPassword}>
                  <div className="form-group">
                    <label>Contraseña actual *</label>
                    <input
                      type="password"
                      value={passwordData.passwordActual}
                      onChange={(e) => setPasswordData({...passwordData, passwordActual: e.target.value})}
                      className="form-control"
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label>Nueva contraseña *</label>
                    <input
                      type="password"
                      value={passwordData.passwordNueva}
                      onChange={(e) => setPasswordData({...passwordData, passwordNueva: e.target.value})}
                      className="form-control"
                      required
                      minLength="6"
                    />
                    <small className="text-muted">Mínimo 6 caracteres</small>
                  </div>

                  <div className="form-group">
                    <label>Confirmar contraseña *</label>
                    <input
                      type="password"
                      value={passwordData.confirmPassword}
                      onChange={(e) => setPasswordData({...formData, confirmPassword: e.target.value})}
                      className="form-control"
                      required
                      minLength="6"
                    />
                  </div>

                  <div className="modal-actions">
                    <button type="button" className="btn-secondary" onClick={() => {
                      setChangePasswordMode(false);
                      setPasswordData({
                        passwordActual: '',
                        passwordNueva: '',
                        confirmPassword: ''
                      });
                    }}>
                      Cancelar
                    </button>
                    <button type="submit" className="btn-primary">
                      Cambiar Contraseña
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}
              </div>
            </div>
          </div>
  );
};

export default Perfil;